import {Component, Input} from '@angular/core';

import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
  selector: 'app-dropdown-menu',
  imports: [
    MatMenuModule,
    MatButtonModule,
    MatIcon,
    MatTooltipModule
  ],
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss'
})
export class DropdownMenuComponent {

  @Input()
  ariaLabel = 'Open menu';

  @Input()
  imageIconUrl: string | null = null;

  @Input()
  dropdownOpenIconWidth = 12;

  @Input()
  dropdownOpenIconHeight = 12;

  @Input()
  menuClass = '';

  @Input()
  revealOnHover = false;

  @Input()
  textIndicator: string | null = null;

  @Input()
  textIndicatorTooltip: string | null = null;

  materialIconName = 'arrow_drop_down';
}
